import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Divider, Modal, CardContent, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import MainCard from 'components/MainCard';
import { useEffect } from 'react';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { Controller, useForm } from 'react-hook-form';
import AddressSearchSwitcher from './AddressSearchSwitcher';

export function ManagementCompanyZoneWriteLayer({managementCompany, managementCompanyZone, setManagementCompanyZone}) {
  const timezone      = (process.env.REACT_APP_TIMEZONE || 'Asia/Seoul').toLowerCase();
  const { t } = useTranslation();

  //modal 관련
  const { openModal } = useModals();
  const handleAlertClick = (alertMessage) => {
      openModal(modals.alertModal, {
          onClose : () => {
          },
          message: alertMessage,
      });
  };
  
  const [open, setOpen] = useState(false);
  const [addressInfo, setAddressInfo] = useState({});
  const handleOpen = () => {
    console.log(managementCompany)
    if (managementCompany !== null && managementCompany !== undefined) {
      setOpen(true);
    } else {
      handleAlertClick(t('message.common.error.text.management.company.select'));
    }
  }
  const handleClose = () => setOpen(false);

  const { control:zoneControl, register:zoneRegister, handleSubmit:zoneHandleSubmit
    , reset:zoneReset, setValue:zoneSetValue, formState : {isDirty:zoneIsDirty, errors:zoneErrors } } = useForm({});

  useEffect(() => {
    zoneReset();
  },[open])

  const onSubmit = async(data) => {
    console.log(data)
    
    let body = {
      // managementCompany : {id : managementCompany},
      name : data.zoneName,
      address : data.zoneAddress,
      // latitude : addressInfo.lat,
      // longitude : addressInfo.lng
    }
    // if (appLanguage === 'zh-cn') {
    if (timezone === ('Asia/Shanghai').toLowerCase()) {
        body.chinaRegionCode = addressInfo?.chinaRegionCode ?? null;
    } else {
        body.latitude = addressInfo?.lat ?? null;
        body.longitude = addressInfo?.lng ?? null;
    }

    console.log(body)
    setManagementCompanyZone(body)
    // setUserZones(userId, zones)
    handleClose();
  }

    return (
    <>
      <Button variant="outlined" style={{padding:"2px 5px"}} color="primary" onClick={handleOpen} >{t('message.common.btn.create')}</Button>

      <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <MainCard title={t('message.common.subtitle.zone')} modal darkTitle content={false}>
          <div style={{marginTop:"-40px", marginRight:"12px", textAlign:"right"}}>
            <Button variant="contained" color="primary" size="small" onClick={handleClose}>
              {t('message.common.btn.close')}
            </Button>
          </div>
          <CardContent>

            <TableContainer>
            <Table sx={{ minWidth: 600 }} aria-label="simple table" className="list_table pop_table">
                <TableBody>
                  <TableRow>
                    <TableCell className="th" align="center">{t('message.common.subtitle.zone.name')}</TableCell>
                    <TableCell style={{textAlign : "left"}}>
                      <TextField id="zoneName" 
                          aria-invalid={!zoneIsDirty ? undefined : zoneErrors.zoneName ? "true" : "false"}
                          defaultValue={managementCompanyZone ?? ''}
                          key={'zoneName'}
                          {...zoneRegister("zoneName", {
                              required : t('message.common.error.text.zone.name.input')
                          })} 
                          sx={{ m: 1, minWidth: '90%' }} 
                      />
                      {zoneErrors.zoneName && <small role="alert"><br></br>{zoneErrors.zoneName.message}</small>}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="th" align="center">{t('message.common.subtitle.address')}</TableCell>
                    <TableCell style={{textAlign : "left"}}>
                      {/* <TextField id="zoneAddress" 
                          aria-invalid={!zoneIsDirty ? undefined : zoneErrors.zoneAddress ? "true" : "false"}
                          defaultValue={''}
                          key={'zoneAddress'}
                          {...zoneRegister("zoneAddress", {
                              required : t('message.common.error.text.address.input')
                          })} 
                          sx={{ m: 1, minWidth: '90%' }} 
                      /> */}
                      {/* <AddressSearchSwitcher key={'zoneAddress'} control={zoneControl} register={zoneRegister} setValue={zoneSetValue} isDirty={zoneIsDirty}
                        errors={zoneErrors} setAddressInfo={setAddressInfo} objName={'zoneAddress'} defaultVal={addressInfo.address_name || ''} /> */}
                      {/* {zoneErrors.zoneAddress && <small role="alert"><br></br>{zoneErrors.zoneAddress.message}</small>} */}
                      <Controller
                          control={zoneControl}
                          name="zoneAddress"
                          rules={{ required: t('message.common.error.text.address.input') }}
                          render={({ field, fieldState }) => (
                          <AddressSearchSwitcher register={zoneRegister} setValue={zoneSetValue} field={field} fieldState={fieldState} 
                              errors={zoneErrors} setAddressInfo={setAddressInfo} objName={'zoneAddress'} addressInfo={addressInfo} />
                          )}
                      />
                      {zoneErrors.zoneAddress && <small role="alert"><br></br>{zoneErrors.zoneAddress.message}</small>}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <div className='btn_right'>
              <Button variant="contained" color="info" className="small_btn" onClick={zoneHandleSubmit(onSubmit)}>
                {t('message.common.btn.create')}
              </Button>
            </div>

          </CardContent>
          <Divider />

        </MainCard>
      </Modal>
    </>
    )
}

export default ManagementCompanyZoneWriteLayer;
